<div class="row mainRowCls">
  <div class="col-sm-12 col-lg-2 col-md-4 categoryFinishCls paddingZero" style="padding-right: 0px; margin-bottom:10px;">
    <form>
      <!--collapsible panel bar goes here-->
      <kendo-panelbar>
        <kendo-panelbar-item title="{{advanceSearchTxt.categoryLbl?advanceSearchTxt.categoryLbl:advanceSearch.categoryLbl}}" [expanded]="expanded">
          <ng-template kendoPanelBarContent>
            <div style=" overflow-y: scroll; max-height: 300px;">
              <kendo-switch name="selectAllCategory" [(ngModel)]="selectAllCategory"
                            (valueChange)="changeCategorySelection(selectAllCategory)" class="select-all-category">
              </kendo-switch>{{advanceSearchTxt.selectAllLbl?advanceSearchTxt.selectAllLbl:advanceSearch.selectAllLbl}}
              <ul class="ordered-list">
                <li *ngFor="let category of priceBookCategories">
                  <kendo-switch (valueChange)="filterDataTableByCategory($event,category)"
                                name="{{category.name}}"
                                [(ngModel)]="category.checked">
                  </kendo-switch>
                  {{ category.name }}
                </li>
              </ul>
            </div>
          </ng-template>
        </kendo-panelbar-item>
        <kendo-panelbar-item title="{{advanceSearchTxt.finishUppercaseLbl?advanceSearchTxt.finishUppercaseLbl:advanceSearch.finishUppercaseLbl}}">
          <ng-template kendoPanelBarContent>
            <div style="overflow-y: scroll; max-height: 300px;">
              <kendo-switch name="selectAllFinish" [(ngModel)]="selectAllFinish"
                            (valueChange)="changeFinishSelection(selectAllFinish)" class="select-all-category">
              </kendo-switch> {{advanceSearchTxt.selectAllLbl?advanceSearchTxt.selectAllLbl:advanceSearch.selectAllLbl}}
              <ul class="ordered-list">
                <li *ngFor="let finish of itemFinishes ">
                  <kendo-switch (valueChange)="filterDataTableByfinish($event,finish)"
                                name="{{finish.name}}"
                                [(ngModel)]="finish.checked"></kendo-switch>
                  {{ finish.name }}
                </li>
              </ul>
            </div>
          </ng-template>
        </kendo-panelbar-item>


      </kendo-panelbar>
    </form>
  </div>


  <div class="col-lg-10 col-md-8 col-sm-12 adv-search-grid-pwa">
    <!--paddingZero for mobile-->

    <div id="btnContainer" class="btnWeb">

      <button class="mr-2 k-button" style="float:left"
              (click)="resetSearch()">
        {{advanceSearchTxt.clearSearchLbl?advanceSearchTxt.clearSearchLbl:advanceSearch.clearSearchLbl}}
      </button>

      <!-- open popup on toggle click-->
      <button class="btn" (click)="onToggleView()" #listPopup>
        <span class="k-icon k-i-grid-layout"></span> <span class="k-icon k-i-arrow-60-down"></span>
      </button>

      <!-- Grid link popup open-->
      <kendo-popup [anchor]="listPopup" *ngIf="showViewPopup" (click)="onToggleView()">
        <div class="language-content">
          <ul>
            <li class="btnLiCls">
              <button class="btn k-button m-3" (click)="listBtnClick('grid')">
                <span class="k-icon k-i-grid-layout"></span>{{advanceSearchTxt.defaultViewLbl?advanceSearchTxt.defaultViewLbl:advanceSearch.defaultViewLbl}}
              </button>
              <br />
              <button class="btn k-button m-3 btnSize" (click)="listBtnClick('tile')">
                <span class="k-icon k-i-grid-layout"></span>{{advanceSearchTxt.tileViewLbl?advanceSearchTxt.tileViewLbl:advanceSearch.tileViewLbl}}
              </button>
              <button class="btn k-button m-3 btnSize" (click)="listBtnClick('noImg')">
                <span class="k-icon k-i-grid-layout"></span>{{advanceSearchTxt.listViewLbl?advanceSearchTxt.listViewLbl:advanceSearch.listViewLbl}}
              </button>
            </li>
          </ul>
        </div>
        <!--Grid link popup close-->
      </kendo-popup>
      <!--</kendo-popup>
    </div>-->
    </div>

    <div *ngIf="showGridView">

      <kendo-grid #grid #AdvanceSearchGrid [data]="gridView "
                  class="advanceMainGridCls"
                  [sortable]="true"
                  [navigable]="true"
                  [filterable]="true" [groupable]="false"
                  [reorderable]="true" [resizable]="false"
                  [pageSize]="pageSize"
                  [skip]="skip"
                  (sortChange)="gridSortChange($event)"
                  [pageable]="{ buttonCount: 5, info: true, responsive:true, pageSizes:[50,75,100] }" [columnMenu]="false"
                  [sort]="gridState.sort"
                  [filter]="gridState.filter"
                  (pageChange)="pageChange($event)"
                  [loading]="advanceSearchLoading">
        <kendo-grid-column media="(max-width: 1024px)" title="Items">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="row">
              <div style="width:100%">
                <div class="row">
                  <div class="col-5 paddingZero">
                    <div class="row">
                      <div class="col-12 paddingZero">
                        <img class="searchImage" src="{{imageURL}}{{dataItem.imageUrl}}" alt="{{dataItem.itemNumber}}" />
                        <span *ngIf="expanded" style="display:none;">{{isCategoryExpanded(false)}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 searchItemNumber">
                        {{dataItem.itemNumber}}
                      </div>
                    </div>
                    <div class="row" [ngClass]="{'height-35': dataItem.itemType===1 }">
                      <div class="col-12">
                        
                      </div>
                    </div>
                  </div>
                  <div class="col-7 paddingZero">
                    <div class="row">
                      <div class="col-12 item-description">
                        {{dataItem.shortDescription}}
                      </div>
                    </div>
                    <div class="row" *ngIf="dataItem.availableFinish && dataItem.availableFinish.length>0">
                      <div class="col-3 paddingZero" style="padding-top:7px; text-align:left">
                        {{advanceSearchTxt.finishLowercaseLbl?advanceSearchTxt.finishLowercaseLbl:advanceSearch.finishLowercaseLbl}}:
                      </div>
                      <div class="col-9 paddingRightZero">
                        <kendo-dropdownlist [data]="dataItem.availableFinish"
                                            (valueChange)="handleFinishChange($event,dataItem)"
                                            [value]="{value:dataItem.selectedFinish}"
                                            [textField]="'name'" [valueField]="'value'"
                                            [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidFinishValue,'finishStyleCls-small': showImgGrid, 'finishStyleCls-small1':!showImgGrid}">
                        </kendo-dropdownlist>
                        <!--<input type="text" />-->
                      </div>
                    </div>
                    <div class="row" *ngIf="dataItem.selectedFinish==='22'">
                      <div class="col-3 paddingZero" style="padding-top:7px; text-align:left">
                        {{advanceSearchTxt.paintLbl?advanceSearchTxt.paintLbl:advanceSearch.paintLbl}}:
                      </div>
                      <div class="col-9 paddingRightZero">
                        <kendo-dropdownlist [data]="paintValue"
                                            [value]="{value:dataItem.selectedPaint}"
                                            [textField]="'name'"
                                            [valueField]="'value'"
                                            (valueChange)="handlePaintChange($event,dataItem)"
                                            [filterable]="true"
                                            (filterChange)="handlePaintFilter($event)"
                                            class="finishStyleCls-small" [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isEmptyPaint}">

                        </kendo-dropdownlist>
                      </div>
                    </div>
                    <div class="row" *ngIf="dataItem.itemType===1 && dataItem.availableSizes && dataItem.availableSizes.length>0 && dataItem.availableSizes[0].value">
                      <div class="col-3 paddingZero" style="padding-top:7px; text-align:left">
                        {{advanceSearchTxt.sizeLbl?advanceSearchTxt.sizeLbl:advanceSearch.sizeLbl}}:
                      </div>
                      <div class="col-9 paddingRightZero">
                        <kendo-dropdownlist [data]="dataItem.availableSizes"
                                            [textField]="'value'"
                                            [valueField]="'value'"
                                            [value]="{value:dataItem.selectedSize}"
                                            (valueChange)="handleExtruionLengthChange($event,dataItem)"
                                            [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidSize,'finishStyleCls-small': showImgGrid, 'finishStyleCls-small1':!showImgGrid}"></kendo-dropdownlist>
                        <span *ngIf="dataItem.itemType===1 && dataItem?.currentSizes?.length<1">
                          {{dataItem?.size}}
                        </span>
                      </div>
                    </div>
                    <div class="row" *ngIf="dataItem.listPriceFormated">
                      <div class="col-12 paddingZero priceClass">
                        {{advanceSearchTxt.listPriceLbl?advanceSearchTxt.listPriceLbl:advanceSearch.listPriceLbl}}: {{dataItem.listPriceFormated | currency}}
                      </div>
                    </div>

                  </div>
                </div>
                <div class="row" *ngIf="dataItem.itemType===1">
                  <div class="col-4 paddingZero">
                    <div class="row">
                      <div class="col-sm-3 col-md-4 qtyPwa" style="padding-left:8px;">
                        {{advanceSearchTxt.quantityLbl?advanceSearchTxt.quantityLbl:advanceSearch.quantityLbl}}:
                        <!--<kendo-numerictextbox [value]="1"
                            [format]="'n'"
                            [decimals]="decimals"
                            [min]="1"
                            (valueChange)="handleItemQtyChanged($event, dataItem)"
                            [autoCorrect]="autoCorrect"
                            [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidQuantity}"
                            *ngIf="dataItem.itemType===1"
                            class="QuantityCls-sm">
      </kendo-numerictextbox>-->
                      </div>
                      <div class="col-sm-9 col-md-8 paddingZero text-align-center">

                        <app-numeric-text-box [numericData]="dataItem.qty"
                                              [maxQty]=999
                                              (event)="handleItemQtyChanged($event,dataItem)">


                        </app-numeric-text-box>

                      </div>

                    </div>

                  </div>
                  <div class="col-4 paddingLeftZero btnPWA">
                    <button kendoButton [icon]="'shopping-cart'" class="m-2 clearKendoButton btn btn-success btnSizeCls"
                            (click)="addStockItemToCart(dataItem)">
                      {{advanceSearchTxt.addToCartLbl?advanceSearchTxt.addToCartLbl:advanceSearch.addToCartLbl}}
                    </button>
                  </div>
                  <div class="col-4 paddingLeftZero btnPWA">
                    <button kendoButton [icon]="'plus'" class="m-2 btn btn-success btnSizeCls" (click)="addItemToQuote(dataItem)" style="border-color:#adacb3;">
                      {{advanceSearchTxt.addToQuoteLbl?advanceSearchTxt.addToQuoteLbl:advanceSearch.addToQuoteLbl}}
                    </button>
                  </div>

                </div>
                <div class="row" *ngIf="dataItem.itemType===2">
                  <div class="col-8"></div>
                  <div class="col-4 paddingLeftZero">
                    <button kendoButton [icon]="'shopping-cart'" class="m-2 clearKendoButton btn btn-success"
                            style="min-width:125px"
                            (click)="configureItem(dataItem)">
                      {{advanceSearchTxt.buildLbl?advanceSearchTxt.buildLbl:advanceSearch.buildLbl}}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-5 col-md-7"></div>
                  <div class="col-sm-7 col-md-5" style="text-align:right;">
                    <a href="javascript:void(0)" class="link-cls" kendoButton (click)="commonlyOrderItems(dataItem)">
                      Commonly order with Item
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="itemId" *ngIf="showImgGrid" title="{{advanceSearchTxt.imageLbl?advanceSearchTxt.imageLbl:advanceSearch.imageLbl}}" [filterable]="false" [sortable]="false" [editable]="false"
                           [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem>

            <div class="product">
              <img src="{{imageURL}}{{dataItem.imageUrl}}" alt="{{dataItem.itemNumber}}" style="height:100px;width:100px;" />
              <!--<img imageLoader src="{{imageURL}}{{dataItem.imageUrl}}" alt="{{dataItem.itemNumber}}" style="height:100px;width:100px;" />-->
              <span *ngIf="!expanded" style="display:none;">{{isCategoryExpanded(true)}}</span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="itemNumber" title="{{advanceSearchTxt.itemLbl?advanceSearchTxt.itemLbl:advanceSearch.itemLbl}}" [columnMenu]="false" [filterable]="true" [editable]="false" [width]="120">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column"
                                           [filter]="filter"
                                           (inputBlur)="applyFilter($event,'itemNumber')"
                                           (input)="onFilter($event,'itemNumber')">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="shortDescription" title="{{advanceSearchTxt.descriptionLbl?advanceSearchTxt.descriptionLbl:advanceSearch.descriptionLbl}}" [editable]="false" [width]="150">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column"
                                           [filter]="filter"
                                           (blur)="applyFilter($event,'shortDescription')"
                                           (input)="onFilter($event,'shortDescription')">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="listPriceFormated" title="{{advanceSearchTxt.listPriceLbl?advanceSearchTxt.listPriceLbl:advanceSearch.listPriceLbl}}" format="{0:c}" [width]="130"
                           editor="numeric" [filterable]="false"
                           [sortable]="false"
                           [editable]="false">
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="availableFinish" title="{{advanceSearchTxt.finishLowercaseLbl?advanceSearchTxt.finishLowercaseLbl:advanceSearch.finishLowercaseLbl}}" [editable]="false" [width]="150"
                           [filterable]="false" [sortable]="false">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <kendo-dropdownlist [data]="dataItem.availableFinish" *ngIf="dataItem.availableFinish && dataItem.availableFinish.length>0"
                                (valueChange)="handleFinishChange($event,dataItem)"
                                [value]="{value:dataItem.selectedFinish}"
                                [textField]="'name'" [valueField]="'value'"
                                [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidFinishValue,'finishStyleCls': showImgGrid, 'finishStyleCls1':!showImgGrid}">
            </kendo-dropdownlist>
          </ng-template>

        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="paint" title="{{advanceSearchTxt.paintLbl?advanceSearchTxt.paintLbl:advanceSearch.paintLbl}}" [editable]="false" [width]="150"
                           [filterable]="false" [sortable]="false">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <kendo-dropdownlist [data]="paintValue"
                                [value]="{value:dataItem.selectedPaint}"
                                [textField]="'name'"
                                [valueField]="'value'"
                                (valueChange)="handlePaintChange($event,dataItem)"
                                *ngIf="dataItem.selectedFinish==='22'"
                                [filterable]="true"
                                (filterChange)="handlePaintFilter($event)"
                                class="finishStyleCls" [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isEmptyPaint}">

            </kendo-dropdownlist>
          </ng-template>

        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="availableFinish" title="{{advanceSearchTxt.sizeLbl?advanceSearchTxt.sizeLbl:advanceSearch.sizeLbl}}" [editable]="false" [filterable]="false" [width]="150"
                           [sortable]="false">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <!--*ngIf="dataItem.availableSizes[0].value != 'N/A'"-->
            <kendo-dropdownlist [data]="dataItem.availableSizes"
                                [textField]="'value'"
                                [valueField]="'value'"
                                [value]="{value:dataItem.selectedSize}"
                                (valueChange)="handleExtruionLengthChange($event,dataItem)"
                                [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidSize,'finishStyleCls': showImgGrid, 'finishStyleCls1':!showImgGrid}"
                                *ngIf="dataItem.itemType===1 && dataItem.availableSizes && dataItem.availableSizes.length>0 && dataItem.availableSizes[0].value"></kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" [filterable]="false" [sortable]="false" field="qty" title="{{advanceSearchTxt.quantityLbl?advanceSearchTxt.quantityLbl:advanceSearch.quantityLbl}}" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-numerictextbox [value]="1"
                                  [format]="'n'"
                                  [decimals]="decimals"
                                  [min]="1"
                                  (valueChange)="handleItemQtyChanged($event, dataItem)"
                                  [autoCorrect]="autoCorrect"
                                  [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidQuantity}"
                                  *ngIf="dataItem.itemType===1"
                                  class="QuantityCls">
            </kendo-numerictextbox>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column media="(min-width: 1050px)" title="{{advanceSearchTxt.selectionLbl?advanceSearchTxt.selectionLbl:advanceSearch.selectionLbl}}" [width]="135" field="isStockItem">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton [icon]="'shopping-cart'" class="m-2 clearKendoButton btn btn-success btnSizeCls"
                    (click)="addStockItemToCart(dataItem)" *ngIf="dataItem.itemType===1">
              {{advanceSearchTxt.addToCartLbl?advanceSearchTxt.addToCartLbl:advanceSearch.addToCartLbl}}
            </button>
            <br>
            <button kendoButton [icon]="'plus'" primary=true class="m-2 btnSizeCls" (click)="addItemToQuote(dataItem)" *ngIf="dataItem.itemType===1">
              {{advanceSearchTxt.addToQuoteLbl?advanceSearchTxt.addToQuoteLbl:advanceSearch.addToQuoteLbl}}
            </button>

            <button kendoButton [icon]="'shopping-cart'" class="m-2 clearKendoButton btn btn-success"
                    *ngIf="dataItem.itemType===2"
                    style="min-width:125px"
                    (click)="configureItem(dataItem)">
              {{advanceSearchTxt.buildLbl?advanceSearchTxt.buildLbl:advanceSearch.buildLbl}}
            </button>
            <a href="javascript:void(0)" class="link-cls" kendoButton (click)="commonlyOrderItems(dataItem)">
              Commonly order with Item
            </a>
          </ng-template>
        </kendo-grid-command-column>
        <ng-template kendoGridNoRecordsTemplate>
        </ng-template>
        <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
          <kendo-pager-info></kendo-pager-info>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
          <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
        </ng-template>-->
      </kendo-grid>

    </div>
    <div *ngIf="showTilesView">
      <div class="row mainDiv">
        <div class="carousel-inner">
          <div class="item carousel-item active">
            <div class="row">
              <div class="col-sm-12 col-lg-12 col-md-12 noRecord" *ngIf="noRecordFound">{{advanceSearchTxt.tileNoRecordLbl?advanceSearchTxt.tileNoRecordLbl:advanceSearch.tileNoRecordLbl}}</div>
              <div class="col-sm-12 col-lg-4 col-md-4  mainCartView"
                   *ngFor="let dataItem of tileView.data |  paginate: { itemsPerPage: itemsPerPage , currentPage: p, totalItems: totalItems}">
                <div class="thumb-wrapper">

                  <!--<div [ngClass]="(dataItem.itemType===1?'img-boxAdd':'img-boxBuild')">-->
                  <!--Need to give image src dynamically-->
                  <img src=" ../../assets/images/Advance-Search/027010_S.gif" *ngIf="dataItem.itemType===1" class="img-responsive img-fluid"
                       alt="">
                  <img src=" ../../assets/images/1010 Sliding Mall Front/1010-OXOL-OUT.jfif" *ngIf="dataItem.itemType===2" [ngClass]="(dataItem.itemType===1?'img-fluid':'build-Img-fluid')" alt="" />

                  <!--  </div>-->
                  <div [ngClass]="(dataItem.itemType===1?' thumb-content add-content':'thumb-content build-content')">
                    <p>{{dataItem.shortDescription}}</p>
                    <p class="item-price"><span>{{dataItem.itemNumber}}</span></p>
                    <div class="row">
                      <div [ngClass]="(dataItem.itemType===1?'col-6':'col-12')" *ngIf="dataItem.itemType===2 || dataItem.itemType===1">
                        <p for="finish">{{advanceSearchTxt.finishLowercaseLbl?advanceSearchTxt.finishLowercaseLbl:advanceSearch.finishLowercaseLbl}}</p>

                        <kendo-dropdownlist [data]="dataItem.availableFinish"
                                            (valueChange)="handleFinishChange($event,dataItem)"
                                            [value]="{value:dataItem.selectedFinish}"
                                            width="100px"
                                            [textField]="'name'" [valueField]="'value'"
                                            [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidFinishValue,'finishStyleCls': showImgGrid, 'finishStyleCls1':!showImgGrid}">
                        </kendo-dropdownlist>


                      </div>
                      <div class="col-6" *ngIf="dataItem.itemType===1">
                        <p for="finish">{{advanceSearchTxt.sizeLbl?advanceSearchTxt.sizeLbl:advanceSearch.sizeLbl}}</p>
                        <div>
                          <kendo-dropdownlist [data]="dataItem.availableSizes"
                                              [textField]="'value'"
                                              [valueField]="'value'"
                                              width="100px"
                                              [value]="{value:dataItem.selectedSize}"
                                              (valueChange)="handleExtruionLengthChange($event,dataItem)"
                                              [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidSize,'finishStyleCls': showImgGrid, 'finishStyleCls1':!showImgGrid}"
                                              *ngIf="dataItem.itemType===1"></kendo-dropdownlist>

                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="dataItem.selectedFinish==='22'">
                      <div class="col-sm-12">
                        <p class="paint-lbl">{{advanceSearchTxt.paintLbl?advanceSearchTxt.paintLbl:advanceSearch.paintLbl}}</p>
                        <div>
                          <kendo-dropdownlist [data]="paintValue"
                                              [value]="{value:dataItem.selectedPaint}"
                                              [textField]="'name'"
                                              [valueField]="'value'"
                                              (valueChange)="handlePaintChange($event,dataItem)"
                                              class="finishStyleCls float-left" [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isEmptyPaint}">

                          </kendo-dropdownlist>
                        </div>
                      </div>
                    </div>
                    <div class="row" [ngClass]="(dataItem.itemType===1?'row qtyDivCls':'row')" *ngIf="dataItem.itemType===1">
                      <div class="col-6">
                        <p>{{advanceSearchTxt.quantityLbl?advanceSearchTxt.quantityLbl:advanceSearch.quantityLbl}}</p>
                        <kendo-numerictextbox [value]="1"
                                              [format]="'n'"
                                              [decimals]="decimals"
                                              [min]="1"
                                              (valueChange)="handleItemQtyChanged($event, dataItem)"
                                              [autoCorrect]="autoCorrect"
                                              *ngIf="dataItem.itemType===1"
                                              [ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidQuantity}"
                                              class="QuantityCls">
                        </kendo-numerictextbox>

                      </div>
                      <div class="col-6">
                        <p>{{advanceSearchTxt.priceLbl?advanceSearchTxt.priceLbl:advanceSearch.priceLbl}}</p>
                        <div class="base-price">{{dataItem.basePrice|currency}}</div>
                      </div>

                    </div>
                    <div>

                    </div>
                    <div>
                      <button class="btn btn-success k-button cartBtnCls btnGreenBorderCls  m-2"
                              (click)="addItemToCart(dataItem)" *ngIf="dataItem.itemType===1">
                        <span class="k-icon k-i-shopping-cart ng-star-inserted"
                              role="presentation"></span>{{advanceSearchTxt.addToCartLbl?advanceSearchTxt.addToCartLbl:advanceSearch.addToCartLbl}}
                      </button>
                      <button class="btn btn-success k-button cartBtnCls btnGreenBorderCls  m-2"
                              (click)="configureItem(dataItem)" *ngIf="dataItem.itemType===2">
                        <span class="k-icon k-i-shopping-cart ng-star-inserted"
                              role="presentation"></span>{{advanceSearchTxt.buildLbl?advanceSearchTxt.buildLbl:advanceSearch.buildLbl}}
                      </button>
                    </div>
                    <div>
                      <button class="btn k-button cartBtnCls  m-3"
                              (click)="addItemToQuote(dataItem)" *ngIf="dataItem.itemType===1">
                        <span class="k-icon k-i-plus ng-star-inserted"
                              role="presentation"></span>{{advanceSearchTxt.addToQuoteLbl?advanceSearchTxt.addToQuoteLbl:advanceSearch.addToQuoteLbl}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>


        </div>

      </div>

      <div class="row paginationCls">
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-8">
              <pagination-controls directionLinks="true"
                                   responsive="true"
                                   previousLabel="Previous"
                                   nextLabel="Next"
                                   screenReaderPaginationLabel="Pagination"
                                   screenReaderPageLabel="page"
                                   screenReaderCurrentLabel="You're on page"
                                   (pageChange)="handlePageChange(p=$event)"></pagination-controls>
            </div>
            <div class="col-sm-4">
              <select (change)="handlePageSizeChange($event)">
                <option *ngFor="let size of totalPageSizes" [ngValue]="size">
                  {{ size }}
                </option>
              </select> {{advanceSearchTxt.tileItemPerPageLbl?advanceSearchTxt.tileItemPerPageLbl:advanceSearch.tileItemPerPageLbl}}
            </div>
          </div>

        </div>
        <!-- showing totals of item at right side-->
        <div class="col-sm-3" style="text-align:right;">
          {{ (p - 1) * itemsPerPage + 1 }} - {{ p * itemsPerPage }} of {{ totalItems }} {{advanceSearchTxt.itemsLbl?advanceSearchTxt.itemsLbl:advanceSearch.itemsLbl}}
        </div>

      </div>

    </div>


    <!--<div class="row" *ngIf="showCommonlyOrderedItems">
    <div class="col-sm-6">
    </div>
    <div class="col-sm-6">
      <div class="container" style="padding-top:10px;">
        <div class="carousel slide multi-item-carousel" id="theCarousel" data-interval="false">
          <div class="carousel-inner row w-100 mx-auto" style="    padding-top: 20px;    border: 2px solid;">
            <div class="carousel-item col-md-4" *ngFor="let item of commonlyOrderDataList;let isFirstRow=first" [ngClass]="{'active' : isFirstRow}">
              <h6 class="txt-center">{{item.associatedItemNumber}} - {{item.associatedItemDescription}}</h6>
              <img src="{{imageURL}}{{item.imageUrl}}" class="img-fluid mx-auto d-block" (click)="getAssociateItem(item)">
              <p class="txt-center">{{item.basePrice}}</p>
            </div>
          </div>
          <a class="carousel-control-prev prev" href="#theCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next next" href="#theCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  </div>-->
    <section>
      <kendo-dialog *ngIf="showCommonlyOrderedItems" title="Common ordered Item" (close)="closeCommonlyOrderDialog()" class="commonlyOrderDialog">
        <div style="text-align: center; margin: 15px;">
          <div class="carousel slide multi-item-carousel" id="theCarousel" data-interval="false">
            <div class="carousel-inner row w-100 mx-auto" style="    padding-top: 20px;    border: 2px solid;">
              <div class="carousel-item col-md-4" *ngFor="let item of commonlyOrderDataList;let isFirstRow=first" [ngClass]="{'active' : isFirstRow}">
                <h6 class="txt-center">{{item.associatedItemNumber}} - {{item.associatedItemDescription}}</h6>
                <img src="{{imageURL}}{{item.imageUrl}}" class="img-fluid mx-auto d-block" (click)="getAssociateItem(item)">
                <p class="txt-center">{{item.basePrice}}</p>
              </div>
            </div>
            <a class="carousel-control-prev prev" href="#theCarousel" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next next" href="#theCarousel" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </kendo-dialog>
    </section>

  </div>
  <app-add-item-to-quote *ngIf="rowItemQuote?.isOpened"  (addToQuoteCompleteEvent)="receiveData($event)" [inputQuoteData]="rowItemQuote"></app-add-item-to-quote>


</div>
